import { render, staticRenderFns } from "./UploadDragger.vue?vue&type=template&id=315712ef&"
import script from "./UploadDragger.vue?vue&type=script&lang=js&"
export * from "./UploadDragger.vue?vue&type=script&lang=js&"
import style0 from "./UploadDragger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports